import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__button_mjs_d80dd9e7__ from "../button.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__filter_context_mjs_5aebc15f__ from "./filter-context.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_9814e660__ from "../../lib/utils.mjs";
function FilterMatchToggle({ matchMode: propMatchMode, actions: propActions, className }) {
    const contextData = propActions && void 0 !== propMatchMode ? null : (0, __WEBPACK_EXTERNAL_MODULE__filter_context_mjs_5aebc15f__.useFiltersContext)();
    const actions = propActions ?? contextData?.actions ?? {};
    const matchMode = propMatchMode ?? contextData?.matchMode ?? "all";
    const filters = contextData?.filters ?? [];
    if (filters.length < 2) return null;
    const handleToggle = ()=>{
        if (actions.setMatchMode) actions.setMatchMode("all" === matchMode ? "any" : "all");
    };
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_d80dd9e7__.Button, {
        variant: "outline",
        size: "sm",
        onClick: handleToggle,
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_9814e660__.cn)(className, "rounded-lg"),
        children: "all" === matchMode ? "Match all filters" : "Match any filter"
    });
}
export { FilterMatchToggle };
